import {Component, input, output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Button} from "primeng/button";

@Component({
  selector: 'app-modal',
  imports: [
    CommonModule,
    Button
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
// 🔹 Inputs as signals
  isOpen = input<boolean>(false);
  title = input<string>('');
  size = input<'sm' | 'md' | 'lg' | 'xl'>('md');
  showFooter = input<boolean>(true);

  // 🔥 Dynamic Primary Button Inputs
  primaryLabel = input<string>('Save');
  primaryIcon = input<string>('pi pi-check');
  primaryLoading = input<boolean>(false);
  primaryDisabled = input<boolean>(false);
  showPrimary = input<boolean>(true);


  // Outputs
  close = output<void>();
  primaryAction = output<void>();
}
